import { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

const docs = {
  aviso: {
    testId: "legal-page-aviso",
    eyebrow: "Información legal",
    title: "Aviso Legal",
    updated: "Última actualización: septiembre de 2026",
    sections: [
      {
        heading: "1. Titular del sitio web",
        paragraphs: [
          "Denominación Social: AFGESTIONES SOLUCIONES CANARIAS, S.L.",
          "Domicilio: Calle Agustín Millares, 18, 35001 – Las Palmas de Gran Canaria.",
          "Contacto: gestiones@afgestiones.es | Teléfono: +34 674 342 645 (09:00 a 13:00 h).",
        ],
      },
      {
        heading: "2. Actividad",
        paragraphs: [
          "Gestión integral, mantenimiento y administración operativa de comunidades de propietarios y patrimonios inmobiliarios. Los servicios de asesoramiento legal, defensa procesal o peritaje técnico se prestan, en su caso, a través de profesionales independientes legalmente habilitados mediante acuerdos de colaboración externa.",
        ],
      },
      {
        heading: "3. Objeto",
        paragraphs: [
          "Este sitio web tiene carácter informativo y describe los servicios de administración de comunidades y gestión patrimonial prestados por AFGestiones. Los formularios permiten solicitar propuestas, concertar citas y comunicar incidencias comunitarias sin que el mero envío implique relación contractual adicional.",
        ],
      },
      {
        heading: "4. Condiciones de uso",
        paragraphs: [
          "El acceso al sitio web es libre y gratuito. El usuario se compromete a hacer un uso lícito, diligente y conforme a la buena fe de los contenidos y servicios ofrecidos, absteniéndose de emplearlos para actividades contrarias a la ley o lesivas de derechos de terceros.",
        ],
      },
      {
        heading: "5. Propiedad intelectual",
        paragraphs: [
          "Todos los contenidos del sitio web, incluidos textos, diseño, logotipos, fotografías e imágenes, son titularidad de AFGestiones o se utilizan con las licencias correspondientes. Queda prohibida su reproducción, distribución o comunicación pública, total o parcial, sin autorización expresa del titular.",
        ],
      },
      {
        heading: "6. Limitación de responsabilidad",
        paragraphs: [
          "La información publicada tiene carácter orientativo y no constituye asesoramiento jurídico vinculante. AFGestiones no se responsabiliza de los contenidos de sitios web de terceros enlazados desde esta página, que son ajenos a su control.",
        ],
      },
      {
        heading: "7. Legislación aplicable",
        paragraphs: [
          "Estas condiciones se rigen por la legislación española. Para cualquier controversia serán competentes los juzgados y tribunales que correspondan conforme a la normativa vigente.",
        ],
      },
    ],
  },
  privacidad: {
    testId: "legal-page-privacidad",
    eyebrow: "Protección de datos",
    title: "Política de Privacidad",
    updated: "Última actualización: septiembre de 2026",
    sections: [
      {
        heading: "1. Responsable del tratamiento",
        paragraphs: [
          "Responsable: AFGESTIONES SOLUCIONES CANARIAS, S.L. Domicilio: Calle Agustín Millares, 18, 35001 – Las Palmas de Gran Canaria. Contacto: gestiones@afgestiones.es | Teléfono: +34 674 342 645.",
        ],
      },
      {
        heading: "2. Datos que recogemos",
        paragraphs: [
          "Recogemos los datos facilitados voluntariamente a través de los formularios: nombre y apellidos, teléfono, correo electrónico, comunidad o dirección del edificio, descripción de la consulta o incidencia y, cuando el usuario la aporta, una fotografía relacionada con la avería.",
        ],
      },
      {
        heading: "3. Finalidad del tratamiento",
        paragraphs: [
          "Los datos se utilizan para atender consultas, preparar propuestas, concertar citas y gestionar técnica y operativamente las incidencias comunicadas por las comunidades administradas.",
        ],
      },
      {
        heading: "4. Base jurídica",
        paragraphs: [
          "El tratamiento se basa en el consentimiento del interesado, en la aplicación de medidas precontractuales o contractuales y, para las comunidades bajo gestión, en la ejecución del encargo de administración y mantenimiento comunitario.",
        ],
      },
      {
        heading: "5. Plazo de conservación y purga de archivos",
        paragraphs: [
          "Los datos personales se conservan durante el tiempo necesario para atender la solicitud y cumplir las obligaciones legales aplicables.",
          "Las fotografías y archivos aportados en las notificaciones de incidencias se conservan protegidos mediante identificadores UUID v4 durante un plazo máximo de 45 días naturales, tras el cual se eliminan de forma automatizada e irreversible del servidor.",
        ],
      },
      {
        heading: "6. Destinatarios",
        paragraphs: [
          "Para la correcta gestión de la incidencia o consulta, los datos podrán comunicarse a gremios de reparación, empresas de mantenimiento, compañías aseguradoras y letrados o peritos colaboradores externos bajo contrato de encargo de tratamiento.",
          "También utilizamos proveedores tecnológicos de correo electrónico y alojamiento que actúan como encargados del tratamiento conforme al artículo 28 del RGPD. No se ceden datos con fines publicitarios.",
        ],
      },
      {
        heading: "7. Derechos",
        paragraphs: [
          "Puede ejercer sus derechos de acceso, rectificación, supresión, oposición, limitación del tratamiento y portabilidad escribiendo a gestiones@afgestiones.es, indicando el derecho que desea ejercer y adjuntando un documento que acredite su identidad.",
          "Si considera que el tratamiento no se ajusta a la normativa, puede presentar una reclamación ante la Agencia Española de Protección de Datos (www.aepd.es).",
        ],
      },
      {
        heading: "8. Medidas de seguridad",
        paragraphs: [
          "AFGestiones aplica medidas técnicas y organizativas apropiadas para garantizar la confidencialidad, integridad y disponibilidad de los datos personales, conforme al RGPD y a la Ley Orgánica 3/2018 (LOPDGDD).",
        ],
      },
    ],
  },
  cookies: {
    testId: "legal-page-cookies",
    eyebrow: "Cookies",
    title: "Política de Cookies",
    updated: "Última actualización: septiembre de 2026",
    sections: [
      {
        heading: "1. Uso de cookies",
        paragraphs: [
          "Este sitio web utiliza exclusivamente cookies técnicas necesarias para el funcionamiento del portal, la navegación segura y el correcto envío de los formularios.",
        ],
      },
      {
        heading: "2. Cookies que no utilizamos",
        paragraphs: [
          "No utilizamos cookies de publicidad, analítica, seguimiento comportamental, redes sociales ni elaboración de perfiles comerciales.",
        ],
      },
      {
        heading: "3. Gestión y desactivación",
        paragraphs: [
          "Las cookies técnicas son necesarias para que el sitio funcione correctamente y no requieren consentimiento previo. El usuario puede configurar su navegador para bloquearlas o eliminarlas, aunque algunas funciones del portal podrían dejar de estar disponibles.",
        ],
      },
    ],
  },
};

function LegalDoc({ doc }) {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div data-testid={doc.testId} className="min-h-screen bg-white">
      <header className="border-b border-slate-100">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-20 flex items-center justify-between">
          <Link to="/" data-testid="legal-brand" className="font-display font-extrabold text-xl tracking-tight text-slate-900">
            AFGestiones
          </Link>
          <Link
            to="/"
            data-testid="legal-back-link"
            className="inline-flex items-center gap-2 text-sm font-semibold text-slate-500 hover:text-slate-900 transition-colors duration-300"
          >
            <ArrowLeft className="w-4 h-4" /> Volver al inicio
          </Link>
        </div>
      </header>

      <main className="max-w-3xl mx-auto px-4 sm:px-6 pt-20 sm:pt-28 pb-24 sm:pb-32">
        <p className="text-xs uppercase tracking-[0.3em] font-semibold text-slate-400 mb-6">{doc.eyebrow}</p>
        <h1 className="font-display font-extrabold tracking-tight text-slate-900 text-4xl sm:text-5xl" data-testid={`${doc.testId}-title`}>
          {doc.title}
        </h1>
        <p className="mt-4 text-sm text-slate-400">{doc.updated}</p>

        <div className="mt-14 space-y-12">
          {doc.sections.map((section) => (
            <section key={section.heading}>
              <h2 className="font-display font-semibold text-xl text-slate-900 mb-4">{section.heading}</h2>
              {section.paragraphs.map((paragraph, index) => (
                <p key={index} className="text-base text-slate-500 leading-relaxed mb-3">{paragraph}</p>
              ))}
            </section>
          ))}
        </div>
      </main>

      <footer className="border-t border-slate-100 py-10">
        <p className="max-w-3xl mx-auto px-4 sm:px-6 text-xs text-slate-400">
          © 2026 AFGESTIONES SOLUCIONES CANARIAS, S.L. Todos los derechos reservados.
        </p>
      </footer>
    </div>
  );
}

export const AvisoLegal = () => <LegalDoc doc={docs.aviso} />;
export const Privacidad = () => <LegalDoc doc={docs.privacidad} />;
export const Cookies = () => <LegalDoc doc={docs.cookies} />;
